const competitions = [
    {
        title: "Online Monmouth Math Competition",
        about: "The Online Monmouth Math Competition (OMMC) is a relatively new online math competition with very high-quality problems meant for teams of 4. In recent years, it has had over 400 teams from around the world. The contest is held in the Spring and has two rounds — a 25-question computational qualifier round and a 10-question proof-based final round. A near-perfect score is generally required to qualify for the final round.",
        pastResults: <span>In 2023, our top team qualified for the final round with a score of <strong>23/25</strong> on the qualifier and placed <strong>7th</strong> in the final round.</span>,
        recentResults: [["Qualifier Score", "23/25", []], ["Finals Rank", 6, ["number-style"]], ["Number of Teams", "500+", []]]

    },
    {
        title: "ARML Local Contest",
        about: "The ARML Local Contest is similar to the bigger ARML competition but is taken locally across the nation at various sites rather than at the four main sites. The contest is given to smaller teams compared to ARML (usually around 6 students) and is generally easier than ARML.",
        pastResults: <span>In 2023, our team placed <strong>13th</strong>, and our top individual student tied for <strong>6th</strong> place.</span>,
        recentResults: [["Number of Teams", "300+", []], ["Number of Students", "2000+", []], ["Team Rank", 13, ["number-style"]], ["Top Student Rank", 22, ["number-style"]]]
    },
    // {
    //     title: "Mathdash Fall League",
    //     about: "The Mathdash Fall League is a very new competition where teams of 4 compete in various weekly contests individually and as a team. It will be held in the fall of 2024.",
    //     pastResults: <span>In progress.</span>,
    //     recentResults: {}
    // },
];

export default competitions;
